import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import { addKakaoServices, getKakaoServices } from 'api/axios/crux/bcon'
import { KAKAO_SERVICE } from 'features/crux/tracker/modal/kakaoService/KakaoServiceCodes'

const initialState = {
  visible: false,
  tab: KAKAO_SERVICE.plusfriend.name,
  isLoading: false,
  isSubmitting: false,
  selected: {
    plusfriend: [],
    talkstore: [],
    gift: [],
  },
  content: {
    plusfriend: [],
    talkstore: [],
    gift: [],
  },
}
export const fetchKakaoServices = createAxiosThunk(
  'kakaoServiceTrack/fetchKakaoServices',
  (noArgs, { getState }) => {
    const {
      createTrack: { trackId },
      kakaoServiceTrack: { tab: service },
    } = getState().tracker
    return getKakaoServices({ trackId, service })
  }
)
const getTarget = (content, selected) =>
  content
    .filter(({ targetKey }) => selected.includes(targetKey))
    .map(
      ({
        service,
        targetCategory,
        targetKey,
        targetKeyDesc,
        targetKeyUrl,
      }) => ({
        service,
        targetCategory,
        targetKey,
        targetKeyDesc,
        targetKeyUrl,
      })
    )
export const linkKakaoServices = createAxiosThunk(
  'kakaoServiceTrack/linkKakaoServices',
  (noArgs, { getState }) => {
    const {
      createTrack: { trackId },
      kakaoServiceTrack: { selected, content },
    } = getState().tracker
    const plusfriends = getTarget(
      content[KAKAO_SERVICE.plusfriend.name],
      selected[KAKAO_SERVICE.plusfriend.name]
    )
    const talkstores = getTarget(
      content[KAKAO_SERVICE.talkstore.name],
      selected[KAKAO_SERVICE.talkstore.name]
    )
    const gifts = getTarget(
      content[KAKAO_SERVICE.gift.name],
      selected[KAKAO_SERVICE.gift.name]
    )
    const targets = [...plusfriends, ...talkstores, ...gifts]
    return addKakaoServices({ trackId, targets })
  }
)
const kakaoServiceTrackSlice = createSlice({
  name: 'kakaoServiceTrack',
  initialState,

  reducers: {
    showKakaoServices: state => {
      state.visible = true
    },
    hideKakaoServices: () => initialState,
    setTab: (state, { payload }) => {
      state.tab = payload
    },
    addId: (state, { payload }) => {
      state.selected[state.tab].push(payload)
    },
    removeId: (state, { payload }) => {
      const index = state.selected[state.tab].indexOf(payload)
      if (index !== -1) state.selected[state.tab].splice(index, 1)
    },
    checkAll: state => {
      const source = state.content[state.tab]
      state.selected[state.tab] = source.map(({ targetKey }) => targetKey)
    },
    clearId: (state, { payload }) => {
      const source = payload || state.tab
      state.selected[source] = []
    },
  },

  extraReducers: builder => {
    builder.addCase(fetchKakaoServices.pending, state => {
      state.isLoading = true
    })

    builder.addCase(
      fetchKakaoServices.fulfilled,
      (state, { payload: { body } }) => {
        state.content[state.tab] = body
        state.isLoading = false
      }
    )

    builder.addCase(fetchKakaoServices.rejected, state => {
      state.isLoading = false
    })

    builder.addCase(linkKakaoServices.pending, state => {
      state.isSubmitting = true
    })

    builder.addCase(linkKakaoServices.fulfilled, state => {
      state.isSubmitting = false
    })

    builder.addCase(linkKakaoServices.rejected, state => {
      state.isSubmitting = false
    })
  },
})

export const {
  showKakaoServices,
  hideKakaoServices,
  setTab,
  addId,
  removeId,
  checkAll,
  clearId,
} = kakaoServiceTrackSlice.actions
export default kakaoServiceTrackSlice.reducer
